<template>
  <div class="d-flex flex-end col-sm-12 p-md-0" v-if="renderComponent">
    <div id="Prematchstatscore"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'Prematchstatscore',
  data() {
    return {
      renderComponent: false,
    }
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getEventsDetail: 'odds/getEventsDetail',
      getLiveMode: 'odds/getLiveMode',
      getLanguage: 'settings/getLanguage',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
    }),
  },
  methods: {
    ...mapActions({
      setPrematchEventStatscore: 'odds/setPrematchEventStatscore',
      setLiveMode: 'odds/setLiveMode',
      destroyEventLive: 'odds/destroyEventLive',
    }),
    async loadWidget() {
      let checkSkin = _.find(this.getRulesSkin, {
        type: 'statscoreprematch',
        source: this.getEventsDetail[0].sport.id,
        status: true,
      })
      if (!checkSkin) {
        checkSkin = _.find(this.getRulesManager, {
          type: 'statscoreprematch',
          source: this.getEventsDetail[0].sport.id,
          status: true,
        })
      }

      let configuration
      if (checkSkin) {
        configuration = checkSkin.configuration
      }

      const id_event = await this.getEventsDetail[0].sourceStatscore
      // console.log('id_event: ', id_event)
      // console.log('checkSkin: ', checkSkin)
      if (id_event && checkSkin) {
        const result = await axios({
          method: 'get',
          url:
            'https://api.statscore.com/v2/booked-events?client_id=1256&product=prematchcenter&events_details=no&client_event_id=' +
            id_event,
          headers: {
            'content-type': 'application/json',
          },
        })

        if (result.data.api.method.total_items > 0) {
          this.renderComponent = true

          await this.setPrematchEventStatscore(true)

          const d = 'STATSCOREWidgetsEmbederScript'
          if (!window.document.getElementById(d)) {
            (window.STATSCOREWidgets = {}),
              (window.STATSCOREWidgets.onLoadCallbacks = []),
              (window.STATSCOREWidgets.onLoad = function (d) {
                window.STATSCOREWidgets.onLoadCallbacks.push(d)
              })
            const n = window.document.createElement('script')
            ;(n.src = 'https://wgt-s3-cdn.statscore.com/bundle/Embeder.js'),
              (n.async = !0),
              (n.id = d),
              n.addEventListener('error', function (d) {
                for (
                  let n = 0;
                  n < window.STATSCOREWidgets.onLoadCallbacks.length;
                  n++
                )
                  window.STATSCOREWidgets.onLoadCallbacks[n](d)
              }),
              window.document.body.appendChild(n)
          }

          // Hook up when library is loaded and ready to use.
          // You can use this method as many times as necessary - if library
          // is already loaded provided callback will fire immediately
          STATSCOREWidgets.onLoad(err => {
            if (err) {
              switch (err.type) {
                case 'NetworkError':
                  // Handle network error here
                  break

                case 'BrowserNotSupported':
                  // Handle unsupported browser here
                  break
              }

              return
            }

            // Widget will be appended to this HTMLElement.
            //
            // If you are using framework then follow its documentation
            // on how to get DOM Element from your component.
            // Vue.js https://vuejs.org/v2/api/#ref
            // React https://en.reactjs.org/docs/refs-and-the-dom.html
            // Angular https://angular.io/api/core/ElementRef
            const element = document.getElementById('Prematchstatscore')

            // Configuration that you should receive from STATSCORE
            const configurationId = configuration //624b28cc9613b7a8f539e817

            // Input data for widget type you want to embded
            const inputData = {
              eventId: 'm:' + id_event,
              language: this.getLanguage,
            }

            // Optional object with options.
            // You can check available options further in the docs.
            const options = {}

            const widget = new window.STATSCOREWidgets.Widget(
              element,
              configurationId,
              inputData,
              options
            )
          })
        } else {
          this.renderComponent = false
        }
      }
    },
  },
  // watch: {
  //
  //   getEventsDetail(newVaule, oldValu) {
  //     if (newVaule && newVaule[0].sourceStatscore) {
  //       this.getStatscore();
  //     }
  //   }
  // },
  async mounted() {
    // this.$root.$on('reloadStatscore', () => {
    //   this.loadWidget();
    // })

    if (this.getLiveMode == 'preview' && this.getEventsDetail.length > 0) {
      await this.loadWidget()
    }
  },
}
</script>
